import { render, staticRenderFns } from "./IndexNew.vue?vue&type=template&id=1163e601&"
import script from "./IndexNew.vue?vue&type=script&lang=js&"
export * from "./IndexNew.vue?vue&type=script&lang=js&"
import style0 from "./IndexNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports